import React from "react";
import { useLogout } from "./hooks/useLogout";
import { Button } from "./Button";

export function LogoutButton() {
  const logout = useLogout();

  return <Button onClick={logout}>Log out</Button>;
}
